import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ResourceDetailModalProvider } from './components/ResourceDetailModalContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ResourceDetailModalProvider>
    <App />
  </ResourceDetailModalProvider>
);
